import './style.scss';

import React from 'react';
import LoadingSpinner from '../loadingSpinner';
import { baseClasses as getTextClasses } from '../text';

function Button(props) {
  return (
    <button
      type={props.type}
      disabled={props.disabled}
      className={getClassName(props)}
      onClick={props.onClick}
    >
      {props.loading ? <LoadingSpinner inline /> : props.children}
    </button>
  );
}

function getClassName({
  className,
  loading,
  primary,
  secondary,
  dark,
  outline,
  fullWidth,
  raised,
  round,
  rect,
  margin,
  borderRadius,
  textStyles
}) {
  return []
    .concat(className ? className : '')
    .concat(loading ? 'button--loading' : '')
    .concat(primary ? 'button--primary' : '')
    .concat(secondary ? 'button--secondary' : '')
    .concat(dark ? 'button--dark' : '')
    .concat(outline ? 'button--outline' : '')
    .concat(fullWidth ? 'button--full-width' : '')
    .concat(raised ? 'button--raised' : '')
    .concat(round ? 'button--round' : '')
    .concat(rect ? 'button--rect' : '')
    .concat(margin === 'none' ? 'button--no-margin' : '')
    .concat(borderRadius === 'none' ? 'button--no-radius' : '')
    .concat(textStyles ? getTextClasses(textStyles) : [])
    .filter(c => !!c)
    .join(' ');
}

export default Button;
